import { render, staticRenderFns } from "./reward_gift_edit.vue?vue&type=template&id=67e2f8aa&scoped=true"
import script from "./reward_gift_edit.vue?vue&type=script&lang=js"
export * from "./reward_gift_edit.vue?vue&type=script&lang=js"
import style0 from "./reward_gift_edit.vue?vue&type=style&index=0&id=67e2f8aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2f8aa",
  null
  
)

export default component.exports